import { render, staticRenderFns } from "./StateBadge.vue?vue&type=template&id=5de6cc13&scoped=true&"
import script from "./StateBadge.vue?vue&type=script&lang=js&"
export * from "./StateBadge.vue?vue&type=script&lang=js&"
import style0 from "./StateBadge.vue?vue&type=style&index=0&id=5de6cc13&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de6cc13",
  null
  
)

export default component.exports